import React from "react";
import { Reveal } from "./shared";
import { WHY } from "../../lib/data";
import logoFull from "../../assets/logo-full.webp";

const beltColors = ["#ffffff", "var(--gold)", "#4C9A2A", "#2E7D32", "#7a4a1e", "var(--black)"];

export const WhyVLA = () => (
  <section className="section" id="why" data-testid="why-section">
    <div className="container">
      <div style={{ display: "grid", gridTemplateColumns: "0.9fr 1.1fr", gap: 60, alignItems: "center" }} className="why-wrap">
        <Reveal className="why-media"
          style={{ position: "relative", borderRadius: "var(--radius-lg)", overflow: "hidden",
            boxShadow: "var(--shadow-strong)", aspectRatio: "4/5",
            background: "radial-gradient(120% 90% at 50% 40%, #FFFFFF 0%, #F5F3EE 70%, #ECE8DF 100%)",
            display: "flex", alignItems: "center", justifyContent: "center" }}>
          {/* brand accents */}
          <span style={{ position: "absolute", top: -70, left: -70, width: 220, height: 220,
            background: "radial-gradient(circle,rgba(193,18,31,0.18),transparent 70%)" }} />
          <span style={{ position: "absolute", bottom: -80, right: -70, width: 240, height: 240,
            background: "radial-gradient(circle,rgba(242,169,59,0.22),transparent 70%)" }} />
          <span style={{ position: "absolute", top: 0, left: 0, right: 0, height: 6,
            background: "linear-gradient(90deg,var(--red) 0 40%,var(--gold) 40% 60%,var(--red) 60% 100%)" }} />
          <img src={logoFull} alt="Victorious Lions Academy crest"
            style={{ width: "72%", position: "relative", zIndex: 1,
              filter: "drop-shadow(0 20px 40px rgba(14,14,14,0.18))" }} />
          <span style={{ position: "absolute", bottom: 26, left: 0, right: 0, textAlign: "center", zIndex: 1,
            fontFamily: "'Bebas Neue'", fontSize: 22, letterSpacing: "0.14em", color: "var(--black)" }}>
            One Pride. <span style={{ color: "var(--red)" }}>Every Rank.</span>
          </span>
        </Reveal>

        <div>
          <Reveal><p className="eyebrow">Why Choose VLA</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="section-title" style={{ marginTop: 16 }}>Trained right. <span className="accent">Every rank.</span></h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="section-sub">From first-timers to competition athletes, every member trains under the same disciplined standard.</p>
          </Reveal>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 22, marginTop: 38 }} className="why-grid">
            {WHY.map((w, i) => (
              <Reveal key={w.title} delay={(i % 2) * 0.08} y={40}>
                <div className="why-item" data-testid={`why-item-${i}`}>
                  <span style={{ display: "inline-block", width: 24, height: 5, borderRadius: 3, marginBottom: 14,
                    background: beltColors[i], border: i === 0 ? "1px solid #ddd" : "none" }} />
                  <h4>{w.title}</h4>
                  <p>{w.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
